(function (angular, app) {
   "use strict";

   app.modules.handicap = {
      name: "app.Handicap"
      , constants: {
      }
      , controllers: {
      }
      , decorators: {
      }
      , directives: {
        
      }
      , filters: {
      }
      , services: {
         handicaps: "ggHandicapFactory"
      }
      , routes: {
         
      }
   };

   angular.module(app.modules.handicap.name, []);

}(angular, app));
